import React from "react";
import TitleWithDash from "@/components/TitleWithDash";
import { PrismicRichText } from "@prismicio/react";
import { PrismicNextLink } from "@prismicio/next";

const titleComponent = {
  heading2: ({ children }) => (
    <h2 className="title-xl text-[#fff] title-font">{children}</h2>
  ),
  heading3: ({ children }) => (
    <h3 className="title-xl text-[#fff] title-font">{children}</h3>
  ),
};

const bodyComponent = {
  heading3: ({ children }) => (
    <h3 className="text-medium text-[#EEB978]">{children}</h3>
  ),
  heading4: ({ children }) => (
    <h4 className="text-medium text-[#EEB978]">{children}</h4>
  ),
  heading5: ({ children }) => (
    <h4 className="text-medium text-[#EEB978]">{children}</h4>
  ),
  paragraph: ({ children }) => (
    <p className="text-medium text-[#EEB978]">{children}</p>
  ),
  strong: ({ children }) => (
    <strong className="font-semibold">{children}</strong>
  ),
  hyperlink: ({ children, node }) => (
    <PrismicNextLink
      field={node.data}
      className="decoration-1 underline-offset-2 text-[#EEB978]"
    >
      {children}
    </PrismicNextLink>
  ),
};

const TextContent = ({ title, description }) => {
  return (
    <div className="flex flex-col xl:flex-row gap-y-[12px] md:gap-y-[18px] xl:gap-y-0 xl:gap-x-[94px]">
      <div className="w-full xl:mt-5">
        <TitleWithDash
          dashColor={"#C4C4C8"}
          title={<PrismicRichText field={title} components={titleComponent} />}
        />
      </div>
      <div className="w-full xl:pe-[90px]">
        <PrismicRichText field={description} components={bodyComponent} />
      </div>
    </div>
  );
};

export default TextContent;
